export default __webpack_public_path__ + "static/media/The Castle.d61aa6bd.jpg";